import { render, staticRenderFns } from "./Serverless.vue?vue&type=template&id=07d774ea&"
import script from "./Serverless.vue?vue&type=script&lang=js&"
export * from "./Serverless.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07d774ea')) {
      api.createRecord('07d774ea', component.options)
    } else {
      api.reload('07d774ea', component.options)
    }
    module.hot.accept("./Serverless.vue?vue&type=template&id=07d774ea&", function () {
      api.rerender('07d774ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/Serverless.vue"
export default component.exports